import {Euler, Vector3, Scene} from "three";

const FLOOR_NUMBER = {
    BOTTOM_FLOOR: 1,
    TOP_FLOOR: 2,
};
// Here we split by Artists Names
//ChatRoom01
//ScreenStageLeft
const CameraLocationsDB = [

    // {
    //     cameraLocationId: '',
    //     floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
    //     locationName: '',
    //     cameraPosition: null,
    //     cameraRotation: null,
    //     displayMesh: 'N', //display/hide mesh - applies only on locations set in Blender. Default is 'Y'
    // },
    // {
    //     cameraLocationId: 'W01Z01',
    //     floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
    //     locationName: `Look Under Seat #1`,
    //     cameraPosition: null,
    //     cameraRotation: null,
    //     displayMesh: 'N',
    // },
    {
        cameraLocationId: 'G01Z01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Alone-Self`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
    },
     {
        cameraLocationId: 'G02Z01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Ravenna`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
    },
     {
        cameraLocationId: 'G03Z01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Artistic Family`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
    },
     {
        cameraLocationId: 'G04Z01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Portraiture`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
    },
     {
        cameraLocationId: 'G05Z01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Nursing Madonna`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
    },
     {
        cameraLocationId: 'G06Z01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Reading Madonna`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
    },
     {
        cameraLocationId: 'G07Z01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Queen of Heaven`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
    },
     {
        cameraLocationId: 'G08Z01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Loving Madonna (Adoring Madonna)`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
    },
     {
        cameraLocationId: 'G09Z01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Holy Family`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
    },
     {
        cameraLocationId: 'G10Z01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Madonna with Saints`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
    },
     {
        cameraLocationId: 'G11Z01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Madonna Purissima`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
    },
];

export {CameraLocationsDB, FLOOR_NUMBER};
